import styled from 'styled-components';
import {Form} from 'antd';

import {IRaiseLabelContentProps} from './RaiseLabel.types';
import {margins} from '../commonProps';

const {Item} = Form;

export const RaiseLabelStyled = styled(Item)`
  && {
    .ant-form-item-label {
      padding: 0px;
    }
    .ant-form-item-control-wrapper {
      padding: 0px;
    }
  }
`;

export const Content = styled.div<IRaiseLabelContentProps>`
  width: 100%;
  ${margins}
  ${(props) =>
    props.isRequired &&
    `label::before {
    display: inline-block;
    margin-right: 4px;
    color: #f5222d;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
    content: '*';
  }`}
`;
